export const columnsToExport = [
  'armador',
  'contenedor',
  'bls',
  'consignatarios',
  'playaActual',
  'tipo',
  'tamano',
  'viaje',
  'llegada',
  'playaDevolucion',
  'fechaLiberadoHasta',
  'fechaRecibirHasta',
  'estadoLiberacion',
];
